import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { Filter, ResourceList, ResourceShow } from '../../../controllers';
import { CurrentVersionField, LinkField, TextField } from '../../../fields';
import { SearchInput } from '../../../inputs';

export default {
  Icon,
  dialogs: {
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <LinkField
          source="library_category_id"
          allowEmpty
        />
        <CurrentVersionField />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="id"
        />
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
